const state = {
  isPlayingVoice: null,
  guideDialogVisible: null
}

const mutations = {
  PLAY_SKILL_VOICE(state, voiceObj) {
    state.isPlayingVoice = voiceObj
  },
  GUIDE_SELECT(state, visible) {
    state.guideDialogVisible = visible
  }
}

const actions = {
  playSkillVoice({ commit }, payload) {
    commit('PLAY_SKILL_VOICE', payload)
  },
  guideSelect({ commit }, visible) {
    commit('GUIDE_SELECT', visible)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
